import React, { useState } from 'react';
import { usePublicData } from '../../context/PublicDataContext';
import { useWishlist } from '../../context/WishlistContext';
import { Eyebrow, Display, GhostButton } from './components/ui';
import ProductCard from './components/ProductCard';
import QuickViewModal from './components/QuickViewModal';
import Seo from './components/Seo';

export default function WishlistPage() {
  const { products, siteName } = usePublicData();
  const { ids } = useWishlist();
  const [quick, setQuick] = useState(null);

  const saved = products.filter((p) => ids.includes(String(p.id)));

  return (
    <>
      <Seo title="Wishlist" description="Your saved pieces." siteName={siteName} />
      <section className="pt-36 pb-12 bg-[#ece0cd]">
        <div className="max-w-6xl mx-auto px-6">
          <Eyebrow>Saved for later</Eyebrow>
          <Display as="h1" className="text-4xl md:text-[52px] mt-4">Your wishlist</Display>
        </div>
      </section>

      <section className="py-16 min-h-[40vh]">
        <div className="max-w-6xl mx-auto px-6">
          {saved.length ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
              {saved.map((p) => <ProductCard key={p.id} product={p} onQuickView={setQuick} />)}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="font-display text-2xl mb-2">Nothing saved yet</p>
              <p className="text-[#4a3d32] text-sm mb-6">Tap the heart on any piece to keep it here.</p>
              <GhostButton to="/products">Browse the range</GhostButton>
            </div>
          )}
        </div>
      </section>

      {quick && <QuickViewModal product={quick} onClose={() => setQuick(null)} />}
    </>
  );
}
